import { render, staticRenderFns } from "./DenominatorSelectEditor.vue?vue&type=template&id=310c564b&scoped=true&"
import script from "./DenominatorSelectEditor.vue?vue&type=script&lang=js&"
export * from "./DenominatorSelectEditor.vue?vue&type=script&lang=js&"
import style0 from "./DenominatorSelectEditor.vue?vue&type=style&index=0&id=310c564b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310c564b",
  null
  
)

export default component.exports